<template>
  <v-container :fluid="true" class="ma-0 pa-0">
    <v-row v-if="$vuetify.display.width >= 1280" no-gutters class="header bg-light-blue">
      <div class="header__text">
        <v-img
            :width="$vuetify.display.width > 1560 ? 644 : 500"
            :src="header_text"
            alt="header_logo"
        />
      </div>
      <div class="header__image">
        <v-img
            :src="header_img"
            :width="$vuetify.display.width > 1560 ? 233 : 170"
            aspect-ratio="1/1"
            :cover="true"
            alt="header_logo"
        />
      </div>
    </v-row>
    <v-row no-gutters justify="center" class="mobile__container" v-else>
      <v-col cols="12" align-self="center" class="mobile__logo">
        <v-img
            :src="mobile_logo"
            :width="114"
            aspect-ratio="1/1"
            :cover="true"
            alt="header_logo"
            @click="navigateTo()"
        />
        <button :class="active ? 'nav-toggle active' : 'nav-toggle'" type="button" @click="active = !active">
          <span class="nav-toggle__item">Menu</span>
        </button>
      </v-col>
    </v-row>
    <div class="burger__menu" v-if="active">
      <BurgerMenu
          @changeRouter="() => { active = false }"
      />
    </div>
  </v-container>
</template>

<script>
import header_img from "@/assets/img/header_logo.png"
import header_text from "@/assets/img/header_text.svg"
import mobile_logo from "@/assets/img/mobile_logo.svg"
import BurgerMenu from "@/modules/personal_account/menus/left_menu/BurgerMenu.vue"
import pa_names from "@/modules/personal_account/routers/names"

export default {
  name: 'PageHeader',
  components: { BurgerMenu },
  data () {
    return {
      header_img: header_img,
      header_text: header_text,
      mobile_logo: mobile_logo,
      active: false,
    }
  },
  computed: {},
  methods: {
    navigateTo () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: pa_names.MAIN })
    },
  },
}
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 200px;
  position: relative;
  justify-content: center;
  border-bottom: 1px solid #313743;
  z-index: 1000;
}

.header__image {
  align-self: end;
  position: absolute;
  right: 83px;
}

.header__text {
  align-self: center;
}

.mobile__container {
  width: 100%;
  position: fixed;
  z-index: 1000;
  height: 60px;
  background: #313743;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.4);
}

.mobile__logo {
  display: inline-grid;
  justify-content: space-between;
  margin-left: 30px;
}

/* Nav toggle */
.nav-toggle {
  width: 30px;
  padding: 10px 0;
  display: block;

  font-size: 0;
  color: transparent;

  border: 0;
  background: none;
  cursor: pointer;

  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
}

.nav-toggle:focus {
  outline: 0;
}

.nav-toggle__item {
  display: block;
  width: 100%;
  height: 3px;

  background-color: #fff;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;

  transition: backgroung .2s linear;
}

.nav-toggle.active .nav-toggle__item {
  background: none;
}

.nav-toggle__item::before,
.nav-toggle__item::after {
  content: "";
  width: 100%;
  height: 3px;

  background-color: #fff;

  position: absolute;
  left: 0;
  z-index: 1;

  transition: transform .2s linear;
}

.nav-toggle__item::before {
  top: -8px;
}

.nav-toggle__item::after {
  bottom: -8px;
}

.nav-toggle.active .nav-toggle__item::before {
  transform-origin: left top;
  transform: rotate(45deg) translateX(-3px);
}

.nav-toggle.active .nav-toggle__item::after {
  transform-origin: left bottom;
  transform: rotate(-45deg) translateX(-3px);
}

.burger__menu {
  background: #3254B9;
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 60px;
  width: 100%;
  max-width: 100vw;
  height: 100%;
  z-index: 999;
}

@media screen and (max-width: 1560px) {
  .header {
    height: 150px;
  }
}
</style>
